import React, { useEffect } from 'react';
import { getTiktokAuthorizeUrl } from 'api/marketPlaces';
import { showAlert } from 'components/Alert';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { Input, InputGrid } from 'components/Form';
import { SubmitHandler, useForm } from 'react-hook-form';
import { channels } from 'shared/constants';
import { useAppStore } from 'stores/appStore';
import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import ButtonReauthorization from 'pages/Onboarding/StepTwo/ButtonReauthorization';
import { AsyncButton } from 'components/ButtonNew/Button';
import { Button } from '@mui/material';
import ButtonAuthorization from 'pages/Onboarding/StepTwo/ButtonAuthorization';

interface FormValues {
  store_name: string;
}

interface TiktokConnectProps {
  chData?: {
    extra_info: {
      shop_name: string;
    }
  }
  isConnected?: boolean;
}

const TiktokContent: React.FunctionComponent<TiktokConnectProps> = ({ chData, isConnected = false }) => {
  const { register, handleSubmit, setValue } = useForm<FormValues>();
  const { indexAccordion, disablePrevButton } = useAppStore();
  const [busy, setBusy] = React.useState<boolean>(false);

  const onSubmit: SubmitHandler<FormValues> = async (value) => {
    setBusy(true);
    try {
      const res: any = await getTiktokAuthorizeUrl(indexAccordion, disablePrevButton);
      if (res && res?.data && res?.data?.status == 'ok') {
        window.location.href = res?.data?.redirect;
      } else {
        showAlert('error', `${res?.data?.message}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (isConnected && chData?.extra_info?.shop_name) {
      // Set the store name from the connected data
      setValue('store_name', chData.extra_info.shop_name);
    }
  }, [isConnected, chData]);

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.TIKTOK} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="tiktok_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label>Nama Toko</Label>}
            input={
              <Input
                isError={false}
                type={'text'}
                placeholder={'nama toko'}
                disabled={isConnected}
                {...register('store_name')}
              />
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ButtonReauthorization {...{ isConnected, form: 'tiktok_form' }} />
            <ButtonAuthorization {...{ form: 'tiktok_form', disable: isConnected }} />
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default TiktokContent;
